import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
      class: "form-input",
      id: "category"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.value,
          value: option.value
        }, _toDisplayString(option.text), 9, _hoisted_2))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.selected]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_base_svg_icon, {
        class: "w-6 fill-current",
        path: _ctx.mdiChevronDown
      }, null, 8, ["path"])
    ])
  ]))
}